import { useLocation } from 'react-router-dom';
import LegalDocumentPage from '@/pages/legal/LegalDocumentPage';
import { legalDocuments } from '@/pages/legal/legalDocuments';
import NotFound from '@/pages/NotFound';
export default function PublicLegalPage() {
  const { pathname } = useLocation();
  const document = Object.values(legalDocuments).find(document => document.route === pathname);
  return document ? <LegalDocumentPage legalDocument={document} /> : <NotFound />;
}
